import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { Card, Grid, Table } from "antd"
// import TableAction from "../../../components/TableAction";
import { useEffect } from "react";
import useTitleStore from "../../../store/titleStore";
import { useTableHeight } from "../../../hooks/useTableHeight";
import { businessAreaService } from "../../../services/business-area.service";

export default function BusinessAreaIndex(){

  const breakpoint = Grid.useBreakpoint()

  const { setTitle } = useTitleStore();

  const tableHeight = useTableHeight(290);


  useEffect(() => {
    setTitle("Area Bisnis");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const { data: businessAreaData , isLoading, isRefetching } = useQuery({
    queryKey: ['businessArea'],
    queryFn: () => businessAreaService.fetchAll(),
    placeholderData: keepPreviousData,
  })

  const businessArea = businessAreaData?.responseData;


  const columns = [
    {
      title: 'No',
      align: 'center',
      width: 60,
      fixed: breakpoint.md && 'left',
      render: (text, record, index) =>  index + 1,
    },
    {
      title: 'Nama',
      dataIndex: 'NAMA_AB',
      width: 180,
      fixed: breakpoint.md && 'left',
    },
    {
      title: 'Jalan',
      dataIndex: 'AREA',
      width: 180
    },
    // {
    //   className: 'last-cell-p',
    //   title: 'Aksi',
    //   align: 'right',
    //   width: 120,
    //   fixed: 'right',
    //   render: record => (
    //     <TableAction
    //       onClickEdit={() => navigate('/master-data/business-area/detail/'+record.id)}
    //       handleDelete={() => handleDelete(record.id)}
    //       deleteLoading={deleteLoading}
    //     />
    //   )
    // },
  ]

  return (
    <>
      <Card
        styles={{
          body: {
            paddingLeft: 0,
            paddingRight: 0
          }
        }}
      >
        <Table
          columns={columns}
          size="small"
          loading={isLoading || isRefetching}
          rowKey={'OBJECTID'}
          scroll={{ y: tableHeight }}
          dataSource={businessArea}
          pagination={false}
        />
        {/* <Pagination
          style={{ marginInline: 24, marginTop: 16 }}
          total={pagination.total}
          showSizeChanger
          pageSizeOptions={['10', '20', '50']}
          current={pagination.page}
          pageSize={dataParams.limit}
          align="end"
          onChange={handleChangePage}
        /> */}
      </Card>
    </>
  )
}